// extracted by mini-css-extract-plugin
export var container = "QuestionScreen-module--container--RUM-+";
export var contentContainer = "QuestionScreen-module--contentContainer--byOmw";
export var sketchPanel = "QuestionScreen-module--sketchPanel--tiChW";
export var questionPanel = "QuestionScreen-module--questionPanel--pPpme";
export var caption = "QuestionScreen-module--caption--q1BnT";
export var question = "QuestionScreen-module--question--GjkX0";
export var answersContainer = "QuestionScreen-module--answersContainer--Hi+G0";
export var answer = "QuestionScreen-module--answer--VZXdd";
export var selectedAnswer = "QuestionScreen-module--selectedAnswer--AsukW";